import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './missions.css'
import { faList } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react';
import Title from '../../components/title';
import TableComponent from '../../components/TableComponent';
import API from '../../api/axiosConfig';

function Missions() {
    const columns = [
        // { name: "الاسم", key: "name" },
        { name: "عنوان المهمة", key: "title" },
        { name: "تاريخ البداية", key: "start_date" },
        { name: "تاريخ النهاية", key: "end_date" },
        { name: "حالة المهمة", key: "status" },
        { name: "", key: "actions" },
    ];


    const [rows, setRows] = useState([]);




    const dropdownOptions = [
        { label: "عرض", route: "/showMissions/:id" },
        { label: "تعديل", route: "/editMissions/:id" },
        { label: "حذف", action: (id) => { 
            if (window.confirm("هل أنت متأكد من حذف هذه المهمة؟")) {
                // Call API to delete the mission
                API.get(`/missions/${id}/delete`)
                    .then((response) => {
                        alert("تم حذف المهمة بنجاح");
                        // Refresh the table data
                        setRows(rows.filter(row => row.id !== id));
                    })
                    .catch((error) => {
                        console.error("There was an error deleting the mission!", error);
                        alert("حدث خطأ أثناء حذف المهمة");
                    });
            }
            }
         }
    ];

    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const modifyRow = (row) => {
        let newRow = { ...row };
        newRow.status = row.status === 1 ? "قيد التنفيذ" : "مكتملة ";
        return newRow;
    }

    return (
        <>
            <div className='missions'>
                <Title title="المهام" icon={<FontAwesomeIcon icon={faList} />} style={{ width: "unset" }} />
                <TableComponent
                    apiUrl={"/missions"}
                    columns={columns}
                    search={false}
                    dropdownOptions={dropdownOptions}
                    handleDownload={handleDownload}
                    transformRowFn={modifyRow}
                />
            </div>
        </>
    )
}

export default Missions